import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Fade from '@mui/material/Fade';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Table from 'Components/UI/Table';
import LoadMoreButton from 'Components/UI/Table/LoadMoreButton';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

const styles = (theme) => ({
  root: {},
  tableTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(4),
  },
  tableTitleContainerMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(4),
  },
  tableTitleButtonMobile: {
    margin: theme.spacing(2, 0),
  },
});

const WithdrawalsTransfersTableView = ({
  className,
  classes,
  type,
  columns,
  data,
  hasNextLink,
  loading,
  onRowClick,
  HeaderButtonProps,
  loadMoreItems,
  showHeaderButton,
  forceUseMobileLayout,
}) => {
  let isMobile = useMobileLayout();
  isMobile = forceUseMobileLayout || isMobile;

  return (
    <Fade in timeout={1000}>
      <div className={classNames(classes.root, className)}>
        <div
          className={classNames({
            [classes.tableTitleContainer]: !isMobile,
            [classes.tableTitleContainerMobile]: isMobile,
          })}
        >
          <Typography
            variant={'h3'}
            color={'primary'}
            weight={'bold'}
          >
            {type}
          </Typography>
          {showHeaderButton && (
            <RoundedButton
              className={classNames({
                [classes.tableTitleButtonMobile]: isMobile,
              })}
              variant={isMobile ? 'contained' : 'text'}
              size={isMobile ? 'large' : 'medium'}
              color={'primary'}
              startIcon={<AddCircleIcon />}
              padding={'dense'}
              disableElevation
              {...HeaderButtonProps}
            >
              {`Make ${type.slice(0, -1)}`}
            </RoundedButton>
          )}
        </div>
        <Table
          columns={columns}
          data={data}
          onRowClick={row => onRowClick && onRowClick(row)}
          PlaceholderMessageProps={{
            message: `No ${type.toLowerCase()} to show.`,
            test: `managed-account-${type.toLowerCase()}-table-placeholder`,
          }}
          RowItemProps={{
            test: `${type.toLowerCase()}-table-row-item`,
          }}
          test={`managed-account-${type.toLowerCase()}-table`}
          forceUseMobileLayout={forceUseMobileLayout}
        />
        {data.length >= 1 && (
          <LoadMoreButton
            hasMoreItems={hasNextLink}
            loadMoreItems={loadMoreItems}
            loading={loading}
          />)
        }
      </div>
    </Fade>
  );
};

WithdrawalsTransfersTableView.defaultProps = {
  className: '',
  showHeaderButton: true,
  forceUseMobileLayout: false,
};

WithdrawalsTransfersTableView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  hasNextLink: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func.isRequired,
  HeaderButtonProps: PropTypes.object.isRequired,
  loadMoreItems: PropTypes.func.isRequired,
  showHeaderButton: PropTypes.bool,
  forceUseMobileLayout: PropTypes.bool,
};

export default withStyles(styles)(WithdrawalsTransfersTableView);
